<template>
    <section class="denticao-report-line" :data-id="'layer_tipoDenticao'">
        <template v-if="execMode == gConsts.rt.execModes.WORK">
            <tipo-denticao-report-select></tipo-denticao-report-select>
        </template>
        <template v-else>
            <report-line-text :text="selectedDenticaoReportText"></report-line-text>
        </template>

        <dentes-seg-report-line-text></dentes-seg-report-line-text>
    </section>
</template>

<script>    
import { gConsts } from '@/globals/gConsts';
import { mapGetters } from 'vuex';
import reportLineText from '@/features/report/components/text/reportLineText.vue';
import tipoDenticaoReportSelect from '@/features/report/components/select/tipoDenticaoReportSelect.vue';
import dentesSegReportLineText from '@/features/report/components/text/dentesSegReportLineText.vue';

export default {
    name: 'denticaoReportLineCMP',
    components: {
        reportLineText,
        tipoDenticaoReportSelect,
        dentesSegReportLineText,
    },
    props: {
        execMode: {
            type: String,
            default: gConsts.rt.execModes.WORK
        }
    },
    data() {
        return {
            gConsts: gConsts,
        }
    },
    computed: {
        ...mapGetters([
            'GET_selectedDenticaoReportNode',
        ]),

        selectedDenticaoReportText() {
            return this.GET_selectedDenticaoReportNode?.reportText || 'Paciente apresenta-se na dentição [indefinida]'
        },
    }
}
</script>

<style scoped>

.denticao-report-line {
    text-align: left;
    cursor: default;
}

/** Relatorio */

#relatorio[data-exec-mode="work"] .denticao-report-line {
    border-left: 3px solid var(--color-primary);
    padding-left: var(--spacing-sm);
    padding-block: var(--spacing-xs);
}

</style>